export const useAreCustomAttributesIdentical = () => {
  const areCustomAttributesIdentical = (array1, array2) => JSON.stringify(array1) === JSON.stringify(array2)
  return areCustomAttributesIdentical
}